import { MOBILE_QUERY } from "@/hooks/useMediaQuery";

/**
 * Promise-based replacement for window.confirm().
 *
 *   if (!(await confirmAction({ message: "Supprimer ?", destructive: true }))) return;
 *
 * Phones get a native-style bottom sheet (see <ConfirmHost/>, mounted once in
 * App.js). Desktop keeps the browser's own confirm() so keyboard / automation
 * behaviour there is unchanged.
 */
let host = null;

export function registerConfirmHost(fn) {
  host = fn;
  return () => {
    if (host === fn) host = null;
  };
}

export function confirmAction(options = {}) {
  const { title, message, confirmLabel, cancelLabel, destructive = false } = options;
  const isMobile =
    typeof window !== "undefined" && window.matchMedia?.(MOBILE_QUERY).matches;
  if (!host || !isMobile) {
    const text = [title, message].filter(Boolean).join("\n\n");
    return Promise.resolve(window.confirm(text));
  }
  return host({ title, message, confirmLabel, cancelLabel, destructive });
}
